import { useRef } from 'react';
import { QUERY_STRING } from '../../../enums/QueryString';
import { CHROME_EXTENSION_TOUR_ID } from '../../../config/env';

const useChromeExtension = (): boolean => {
  const isChromeExtensionInstalled = useRef(false);
  const initialized = useRef(false);

  if (!initialized.current) {
    const params = new URLSearchParams(window.location.search);
    const productTour = params.get(QUERY_STRING.INTERCOM_TOUR_ID);

    isChromeExtensionInstalled.current =
      productTour === CHROME_EXTENSION_TOUR_ID;

    initialized.current = true;
  }

  return isChromeExtensionInstalled.current;
};

export default useChromeExtension;
